import "core-js/modules/web.dom-collections.iterator.js";
import { Root, RootErrorBoundary } from "~/routes/#root";
import { buildHomepageLoader } from "~/utils/homepage-loader";
import { cssLinks } from "@ttark/css-links";
var links = () => [...cssLinks("root")];
var loader = buildHomepageLoader("root");
var ErrorBoundary = RootErrorBoundary;
var root_default = Root;
export { ErrorBoundary, root_default as default, links };